import {
  CartQuoteServices,
  CartUpdateServices,
  FlightServices,
  getObjectKeysAsObject,
  FlightPassengerServicesV2,
  AirPFExerciseServices,
  SeatServices,
  ContactInformationServices,
  PassportServices,
  CartFulfillServices,
} from "@hopper-b2b/checkout";
import { NubankPaymentServices } from "../../../checkout/states/payments";
import { withContactTrackingInstrumentation } from "../contactInformationInstrumentation";
import { checkoutServices } from "./common";

const trackAddContactEvent = withContactTrackingInstrumentation(
  ContactInformationServices.trackAddContactEvent
);

export const Services = {
  ...CartFulfillServices,
  ...CartQuoteServices,
  ...CartUpdateServices,
  ...checkoutServices,
  ...FlightServices,
  ...ContactInformationServices,
  trackAddContactEvent,
  ...FlightPassengerServicesV2,
  ...PassportServices,
  ...AirPFExerciseServices,
  ...SeatServices,
  ...NubankPaymentServices,
};

export const ServiceTypes = getObjectKeysAsObject(Services);
